import React, { forwardRef } from "react";
import SessionDetailModal from "pages/dashboard/components/SessionDetailModal";

export const SessionDetailViewer = forwardRef((props, ref) => (

    <SessionDetailModal ref={ref}/>

));

SessionDetailViewer.displayName = 'SessionDetailViewer';